import React from 'react'
import { Box } from 'rebass/styled-components'

const Spacer = ({ children, spacing, ...rest }) => {
    const spaces = spacing || { top: '', right: '', bottom: '', left: '' }
    return (
        <Box mt={spaces.top || ''} mr={spaces.right || ''} mb={spaces.bottom || ''} ml={spaces.left || ''} {...rest}>
            {children}
        </Box>
    )
}

export default Spacer
